export default __webpack_public_path__ + "static/media/scene_mobile.af16713b.webp";